import '../styles/edgeOverview.css';

import Recycle from '@mui/icons-material/AutorenewRounded';
import BarChart from '@mui/icons-material/BarChartRounded';
import GearFill from '@mui/icons-material/SettingsRounded';
import Speedometer2 from '@mui/icons-material/SpeedRounded';
import {Badge, Button, Card} from 'react-bootstrap';
import moment from 'moment';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {isMonitoredLifecycle} from '../constants/edgesConstants';
import {lifecycleStates} from '../../../shared/constants/lifecycleStates';
import {getDisplayNotification} from '../constants/edgesConstants';

const EdgeCard = ({edgeData, updateBalenaStatus}) => {
  const id = edgeData.name;

  const displayNotification = getDisplayNotification(edgeData.currentStates);

  const getStatusVariant = () => {
    if (!isMonitoredLifecycle(edgeData.lifecycle?.status) || !edgeData.currentStates?.deadmanCheck) return 'secondary';
    if (!displayNotification) return 'secondary';
    if (displayNotification.type === 403) return 'warning';
    if (/^[45]/.test(String(displayNotification.type))) return 'danger';
    return 'success';
  };

  const ts = displayNotification?.timestamp;
  const tsDate = ts?.toDate ? ts.toDate() : ts;
  const formattedTimestamp = ts ? moment(tsDate).format('DD.MM.YYYY HH:mm:ss') : 'N/A';
  const description = displayNotification?.shortDescription;
  const hasData = description || formattedTimestamp;

  return (
    <Card className="edge-card" border={edgeData.activated && 'success'}>
      <Card.Body>
        <div className="header">
          <div>
            <h5 className="d-flex align-items-center gap-2 mb-0">
              {id}
              <Badge
                pill
                bg={getStatusVariant()}
                style={{fontFamily: 'monospace', fontWeight: 400, fontSize: '0.80rem'}}
              >
                {edgeData.status?.balena?.releaseVersion || '\u00a0'}
              </Badge>
            </h5>
          </div>
          <div>
            <Link to={`/edges/${edgeData.id}/statistics`}>
              <Button variant="link"><BarChart/></Button>
            </Link>
            {edgeData.isAdmin && (
              <Link to={`/edges/${edgeData.id}/configuration`}>
                <Button variant="link"><GearFill/></Button>
              </Link>
            )}
            {edgeData.meterReport && (
              <Link to={`/edges/${edgeData.id}/meterreport`}>
                <Button variant="link"><Speedometer2/></Button>
              </Link>
            )}
            {edgeData.balenaUpdatePending ? (
              <div
                className="loader ms-1"
                style={{width: '16px', height: '16px', borderWidth: '2px', display: 'inline-block'}}
              />
            ) : (
              <Button
                size="sm"
                variant="link"
                className="p-0 text-secondary"
                style={{lineHeight: 0}}
                onClick={() => updateBalenaStatus(edgeData.id)}
              >
                <Recycle style={{fontSize: '20px'}}/>
              </Button>
            )}
          </div>
        </div>
        <small>
          {hasData ? `${description || ''} at ${formattedTimestamp || ''}` : '\u00A0'}
        </small>
        <div className="d-flex flex-column scc-info">
          {edgeData.immediateTenantName && (
            <div className="d-flex justify-content-between">
              <span className="text-start">Tenant</span>
              <span className="text-end">{edgeData.immediateTenantName}</span>
            </div>
          )}
          <div className="d-flex justify-content-between">
            <span className="text-start">Adresse</span>
            <span className="text-end">{edgeData.address}</span>
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <span className="text-start">LAN IP</span>
            <span className="text-end">{edgeData.status?.balena?.localIp?.toString()}</span>
          </div>
          {edgeData.lifecycle && (
            <div className="d-flex justify-content-between">
              <span className="text-start">Lifecycle</span>
              <span className="text-end">
                <Badge bg={lifecycleStates[edgeData.lifecycle.status]}>
                  {edgeData.lifecycle.status}
                </Badge>
              </span>
            </div>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

EdgeCard.propTypes = {
  edgeData: PropTypes.object.isRequired,
  updateBalenaStatus: PropTypes.func.isRequired,
};

export default EdgeCard;
